/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * チェックイン可否情報
 */
export interface JourneyElementAcceptanceEligibility {
  /**
   * DxAPIのチェックイン不可理由、およびAltea Web Serviceのチェックイン順序チェックの結果から判定したチェックイン可否ステータス<br> eligible：チェックイン可<br> ineligible：チェックイン不可
   */
  status: JourneyElementAcceptanceEligibility.StatusEnum;
}
export namespace JourneyElementAcceptanceEligibility {
  export type StatusEnum = 'eligible' | 'ineligible';
  export const StatusEnum = {
    Eligible: 'eligible' as StatusEnum,
    Ineligible: 'ineligible' as StatusEnum,
  };
}
